// src/pages/adm/grupo/GrupoFiltrarFechasPage.jsx
import React, { useEffect, useState, useMemo } from "react";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { getAllGrupos } from "../../../services/grupo.service";
import { GrupoList } from "../../../modules/grupo/GrupoList";
import { TITULO_GRUPO_LIST } from "../../../utils/constantes";

const GrupoFiltrarFechasPage = () => {
  const [grupos, setGrupos] = useState([]);
  const [mesSeleccionado, setMesSeleccionado] = useState("");

  // 1) Traer todos los grupos al montar
  useEffect(() => {
    (async () => {
      try {
        const todos = await getAllGrupos();
        setGrupos(todos);
      } catch (err) {
        console.error("Error cargando grupos:", err);
      }
    })();
  }, []);

  // 2) Filtrar en memoria según el mes (YYYY-MM) de fechaInicio
  const gruposFiltrados = useMemo(() => {
    if (!mesSeleccionado) return grupos;

    return grupos.filter((g) => {
      if (!g.fechaInicio) return false;
      const fi = new Date(g.fechaInicio);
      // obtenemos "YYYY-MM"
      const ym = `${fi.getFullYear()}-${String(fi.getMonth() + 1).padStart(2, "0")}`;
      return ym === mesSeleccionado;
    });
  }, [grupos, mesSeleccionado]);

  return (
    <ContenedorPageTemplate titulo={TITULO_GRUPO_LIST}>
      <div className="flex flex-col sm:flex-row items-center gap-4 mb-6">
        <div className="flex flex-col">
          <label htmlFor="filtro-mes" className="mb-1 font-semibold">
            Mes de Inicio
          </label>
          <input
            id="filtro-mes"
            type="month"
            className="border border-gray-300 rounded-lg py-2 px-3"
            value={mesSeleccionado}
            onChange={(e) => setMesSeleccionado(e.target.value)}
          />
        </div>
      </div>

      <p className="text-gray-700 font-medium mb-4">
        Total de grupos en {mesSeleccionado || "todos los meses"}: {gruposFiltrados.length}
      </p>

      <GrupoList grupos={gruposFiltrados} />
    </ContenedorPageTemplate>
  );
};

export default GrupoFiltrarFechasPage;
